import { useCurrentStateAndParams } from "@uirouter/react";

import { SI_SEARCH_ROUTES } from "app/common/constants/ad-intelligence-routes";
import { ROUTES } from "single-spa/react-app/config/solutions25/adIntelligence/searchAdvertising/searchAdvertisingConstants";

export interface ISerpPlayersEndpoints {
    table: string;
    enrichTable: string;
    graph: string;
    graphExcel: string;
    domains: string;
    categories: string;
}

const keywordResearchSerpPlayersEndpoints: ISerpPlayersEndpoints = {
    table: "/widgetApi/KeywordAnalysisV2/KeywordAnalysisOrganic/Table",
    enrichTable: "/widgetApi/KeywordAnalysisV2/KeywordAnalysisOrganic/TableSiteDrillDown",
    graph: "/widgetApi/KeywordAnalysisV2/KeywordAnalysisOrganic/SiteTraffic",
    graphExcel: "/api/KeywordAnalysis/Sites/Traffic/Excel",
    domains: "/widgetApi/KeywordAnalysisV2/KeywordAnalysisOrganic/Domains",
    categories: "/widgetApi/KeywordAnalysisV2/KeywordAnalysisOrganic/Categories",
};

const searchAdvertisingSerpPlayersEndpoints: ISerpPlayersEndpoints = {
    table: "/widgetApi/AdIntelligence/Search/KeywordAnalysisOrganic/Table",
    enrichTable: "/widgetApi/AdIntelligence/Search/KeywordAnalysisOrganic/TableSiteDrillDown",
    graph: "/widgetApi/AdIntelligence/Search/KeywordAnalysisOrganic/SiteTraffic",
    graphExcel: "/api/AdIntelligence/Search/Sites/Traffic/Excel",
    domains: "/widgetApi/AdIntelligence/Search/KeywordAnalysisOrganic/Domains",
    categories: "/widgetApi/AdIntelligence/Search/KeywordAnalysisOrganic/Categories",
};

const serpPlayersEndpointsMap: Record<string, ISerpPlayersEndpoints> = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    organicsearch_keywordAnalysis_2: keywordResearchSerpPlayersEndpoints,
    [ROUTES.serpPlayers]: searchAdvertisingSerpPlayersEndpoints,
    // Sales Intelligence mirror of Search Advertising.
    [SI_SEARCH_ROUTES.serpPlayers]: searchAdvertisingSerpPlayersEndpoints,
};

export const useSerpPlayersEndpoints = (): ISerpPlayersEndpoints => {
    const { state } = useCurrentStateAndParams();
    const endpoints = serpPlayersEndpointsMap[state.name as string];

    if (!endpoints) {
        throw new Error(
            `No SERP players endpoints configured for state: ${state.name}. ` +
                `Available states: ${Object.keys(serpPlayersEndpointsMap).join(", ")}`,
        );
    }

    return endpoints;
};
